module.exports = __webpack_public_path__ + "static/img/afc2014008.8863200.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/afc2014008.jpeg
// module id = QyUd
// module chunks = 1